import React, { lazy, PureComponent, Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { s as styles } from '../../link-panel-d6b164a2.js';
import { TextInput } from 'wix-rich-content-ui-components';
import { mergeStyles } from 'wix-rich-content-common';
import { isUndefined } from 'lodash';
import '../../style-inject.es-746bb8ed.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const List = lazy(
  () => import('react-window').then(({ FixedSizeList }) => ({
    default: FixedSizeList
  }))
);
const Downshift = lazy(() => import('downshift'));
function isSubString(str, subStr) {
  return str.toLowerCase().includes(subStr.toLowerCase());
}
function filterItems(items, str) {
  return str ? items.filter(({ value, label }) => isSubString(value, str) || isSubString(label, str)) : items;
}
class ItemRenderer extends PureComponent {
  render() {
    const { items, getItemProps, highlightedIndex, selectedItem, formatMenuItem, inputValue } = this.props.data;
    const { index, style } = this.props;
    const item = items[index];
    return /* @__PURE__ */ React.createElement(
      "div",
      __spreadValues({}, getItemProps({
        item,
        index,
        key: item.value,
        style: __spreadValues({
          backgroundColor: highlightedIndex === index ? "lightgray" : "white",
          fontWeight: selectedItem === item ? "bold" : "normal"
        }, style)
      })),
      formatMenuItem(item, inputValue)
    );
  }
}
__publicField(ItemRenderer, "propTypes", {
  data: PropTypes.object,
  index: PropTypes.number,
  style: PropTypes.object
});
class LinkPanelDropdown extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      selectedItem: { value: this.props.value },
      items: this.props.getItems(),
      fallbackChanged: false
    });
    __publicField(this, "textInput", React.createRef());
    __publicField(this, "styles", mergeStyles({ styles, theme: this.props.theme }));
    __publicField(this, "handleDropDownStateChange", (changes) => {
      if (!isUndefined(changes.selectedItem)) {
        this.setState({ selectedItem: changes.selectedItem });
      }
      if (!isUndefined(changes.inputValue)) {
        const { inputValue } = changes;
        if (!this.state.selectedItem || this.state.selectedItem.value !== inputValue) {
          this.setState({ selectedItem: { value: inputValue } });
        }
        this.setState({
          items: filterItems(this.props.getItems(), inputValue),
          inputValue
        });
        this.props.onChange(inputValue);
      }
    });
  }
  render() {
    const { itemToString, formatMenuItem, itemHeight, textInputProps, value, t } = this.props;
    const { selectedItem, items, fallbackChanged } = this.state;
    return /* @__PURE__ */ React.createElement(
      Suspense,
      {
        fallback: /* @__PURE__ */ React.createElement(
          Input,
          __spreadProps(__spreadValues({}, textInputProps), {
            value,
            onChange: (e) => {
              this.props.onChange(e.target.value);
              this.setState({ fallbackChanged: true });
            },
            placeholder: t("LinkPanel_InputPlaceholder"),
            selectText: true
          })
        )
      },
      /* @__PURE__ */ React.createElement(
        Downshift,
        {
          selectedItem,
          onStateChange: this.handleDropDownStateChange,
          itemToString,
          initialInputValue: value
        },
        ({
          getInputProps,
          getItemProps,
          // getLabelProps,
          getMenuProps,
          isOpen,
          highlightedIndex,
          inputValue
        }) => {
          const inputProps = getInputProps(textInputProps);
          return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Input, __spreadProps(__spreadValues({}, inputProps), { selectText: !fallbackChanged })), (isOpen || this.props.isOpen) && List && /* @__PURE__ */ React.createElement(Suspense, { fallback: /* @__PURE__ */ React.createElement("div", null) }, /* @__PURE__ */ React.createElement(
            List,
            __spreadValues({
              className: styles.linkPanel_dropdownList,
              height: Math.min(items.length * itemHeight + 1, 200),
              itemCount: items.length,
              itemSize: itemHeight,
              itemData: {
                items,
                getItemProps,
                highlightedIndex,
                selectedItem,
                formatMenuItem,
                inputValue
              }
            }, getMenuProps()),
            ItemRenderer
          )));
        }
      )
    );
  }
}
__publicField(LinkPanelDropdown, "propTypes", {
  theme: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  getItems: PropTypes.func,
  t: PropTypes.func,
  itemToString: PropTypes.func,
  value: PropTypes.string,
  formatMenuItem: PropTypes.func,
  itemHeight: PropTypes.number,
  textInputProps: PropTypes.object,
  isOpen: PropTypes.bool
});
class Input extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "textInput", React.createRef());
  }
  componentDidMount() {
    const { selectText } = this.props;
    const ref = this.textInput.current;
    ref.focus();
    if (selectText) {
      ref.select();
    } else {
      ref.selectionStart = ref.selectionEnd = ref.value.length;
    }
  }
  render() {
    const _a = this.props, { placeholder, selectText } = _a, inputProps = __objRest(_a, ["placeholder", "selectText"]);
    return /* @__PURE__ */ React.createElement(
      TextInput,
      __spreadProps(__spreadValues({}, inputProps), {
        inputRef: this.textInput,
        onChange: (value) => inputProps.onChange({ target: { value } }),
        placeholder
      })
    );
  }
}

export { LinkPanelDropdown };
//# sourceMappingURL=LinkPanelDropdown.js.map
